module.exports = __webpack_public_path__ + "media/credit/american-express-fffab15d.png";